// extracted by mini-css-extract-plugin
module.exports = {"VideoCarousel":"VideoCarousel_VideoCarousel__p5AgF"};